<template>
  <v-toolbar app :color="$ENV.VUE_APP_HEADER_COLOR" dark class="hidden-print-only">
    <v-toolbar-side-icon @click="toggleNavigationDrawer()"></v-toolbar-side-icon>
    <!-- <v-spacer></v-spacer>
    <v-text-field label="Search" single-line outline append-icon="search"></v-text-field>-->
    <v-spacer></v-spacer>

    <v-toolbar-items>
      <!-- <v-btn flat>Link One</v-btn>
      <v-btn flat>Link Two</v-btn>
      <v-btn flat>Link Three</v-btn>-->
      <v-menu offset-y v-if="logged && logged.user">
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <v-icon left class="mr-1">account_circle</v-icon>
            {{logged.user.first_name}}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in myAccountMenuItems"
            :key="index"
            @click="item.router_name == 'my_account_logout' ? onLoggedOutClicked() : $router.push({ name: item.router_name })"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn flat @click="$store.commit('common/setIsLoginFormModal', true)" v-else>
        <v-icon left class="mr-1">account_circle</v-icon>Login
      </v-btn>
      <!-- <v-btn flat @click="showCartDrawer(true)">
        <v-badge right color="red" :value="cartTotalQuantity > 0">
          <template v-slot:badge>
            <span>{{cartTotalQuantity}}</span>
          </template>
          <v-icon left flat class="mr-0">shopping_basket</v-icon>
        </v-badge>
      </v-btn> -->
    </v-toolbar-items>

    <!-- <v-btn flat href="#">
      <span class="mr-2">Call: +880 1683 452892</span>
    </v-btn>
    <v-menu offset-y v-if="logged && logged.user">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" round outline>My Account</v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(item, index) in myAccountMenuItems"
          :key="index"
          @click="item.router_name == 'my_account_logout' ? onLoggedOutClicked() : $router.push({ name: item.router_name })"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-btn v-else flat @click="$store.commit('common/setIsLoginFormModal', true)" target="_blank">
      <span class="mr-2">Login</span>
    </v-btn>-->
  </v-toolbar>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "App",
  components: {},
  data() {
    return {
      myAccountMenuItems: [
        // { title: "My Profile", router_name: "my_account_profile" },
        // { title: "My Orders", router_name: "my_account_my_orders" },
        // { title: "Track My Order", router_name: "my_account_track_my_orders" },
        { title: "Logout", router_name: "my_account_logout" }
      ]
    };
  },
  computed: {
    ...mapGetters("cart", {
      // cartProducts: "cartProducts",
      cartTotalQuantity: "cartTotalQuantity"
    })
  },
  methods: {
    ...mapActions("cart", ["showCartDrawer"]),
    ...mapActions("common", ["toggleNavigationDrawer"]),
    onLoggedOutClicked() {
      this.$store.commit("common/setLogged", {});
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<style scoped>
.category-row-llll {
}
</style>